import React from "react";

import { Icon } from "../components/Icon";

import styles from "./ThemeToggle.scss";
import { useTheme } from "./ThemeProvider";

interface ThemeToggleProps {
  /** Icon-only mode; label is moved to the `title` attribute. */
  compact?: boolean;
}

export function ThemeToggle({
  compact = false,
}: ThemeToggleProps): React.ReactElement {
  const { resolvedTheme, setTheme } = useTheme();
  const isDark = resolvedTheme === "dark";
  const label = isDark ? "Toggle light mode" : "Toggle dark mode";

  function handleClick() {
    setTheme(isDark ? "light" : "dark");
  }

  return (
    <button
      type="button"
      className={styles["theme-toggle"]}
      data-testid="theme-toggle-button"
      onClick={handleClick}
      aria-label={label}
      title={compact ? label : undefined}
    >
      <Icon icon={isDark ? "sun" : "moon"} size={16} decorative />
      {!compact && (
        <span className={styles["theme-toggle-label"]}>{label}</span>
      )}
    </button>
  );
}
